import { MATERIAL_LABELS, MaterialLabel } from './material-labels.constants';

type HasVisibleLabelArgs = {
    label: MaterialLabel;
    showQualityLabel: boolean;
    hasSaleOriginalPrice: boolean;
};

const hasVisibleLabel = ({ label, showQualityLabel, hasSaleOriginalPrice }: HasVisibleLabelArgs): boolean => {
    if (!label) {
        return false;
    }

    if (label === MATERIAL_LABELS.HIGH_QUALITY) {
        return showQualityLabel;
    }

    if (label === MATERIAL_LABELS.SALE) {
        return hasSaleOriginalPrice;
    }

    return true;
};

export default hasVisibleLabel;
